export default {
	subtitle: "Credit card transactions in Mexico",
  path: "transaction_cc_mx",
	paragraphs: [
    "For Mexico you will create a credit card transaction calling our API, using the from_credit_card field. Check the payload below to see.",
    "For sandbox, you can use a checkout page sample available on our portal or via the following link. This page will help you understand the needed information and the whole flow from the credit transactions.",
    "We highly recommend testing the checkout page first before initiating direct API calls, because you can adapt it to your front-end environment. Sample checkout pages links:",
    "https://sandbox-portal.facilitapay.com/mxn/checkout_sample_one-time-purchase",
    "https://sandbox-portal.facilitapay.com/mxn/checkout_sample_tokenized/.",
    "The source code for the HTML file is available below.",
    "To create using the API call you will use the following endpoint: "
  ],
  hyperlink: {
    linkPath: "/static/3DSSamplesMX.zip",
    linkText: "Download sample page"
  },
  request: {
    method: "POST",
    endpoint: "/transactions",
    payload: {
      "transaction": {
        "currency": "MXN",
        "exchange_currency": "USD",
        "value": "2000.00",
        "from_credit_card": {
          "card_number": "4456524869770255",
          "card_expiration_date": "03/27",
          "card_security_code": "234",
          "card_brand": "Visa",
          "card_type": "Credit",
          "fullname": "Luiz Abreu Nieto"
        },
        "threeds": { "jwt": "eyJhbGciOiJIUzI1NiIsInR5cC..."
        },
        "to_bank_account_id": "{{partner_usd_account_id}}",
        "subject_id": "{{mx_person_id}}"
      }
    },
    responses: {
      "data": {
        "value": "2000.00",
        "to_bank_account": {
          "routing_number": "Further Credit To / REF: SWS2319371",
          "pix_info": null,
          "owner_name": "REARDEN STEEL CO. Ltd.",
          "owner_document_number": "2348909854385",
          "owner_company": {
            "social_name": "POWER HOME THEATER",
            "id": "f64e512c-1a81-42d9-9ac9-05f369bc98e3",
            "document_type": "tax_id",
            "document_number": "2348909854385"
          },
          "nickname": "Power Conta 1",
          "intermediary_bank_account": null,
          "id": "a1db04a1-ddc9-4aa8-a0a5-2c74cf9505d0",
          "iban": null,
          "currency": "USD",
          "branch_number": null,
          "branch_country": "USD",
          "bank": {
            "swift": "MT2502041",
            "name": "M&T Bank",
            "id": "d6f801e9-57c0-43af-8b11-07b8bd4fff0f",
            "country": null,
            "code": null
          },
          "account_type": "conta-corrente",
          "account_number": "00416612332",
          "aba": null
        },
        "threeds_data": {
          "three_ds_version": "1.0.2",
          "secure_id": "1bff5e25-6cac-4f59-8670-fbce6d00762b",
          "pareq": "sandbox",
          "authentication_transaction_id": "OWgXwASsYPW4hr1ATcf0",
          "acs_url": ""
        },
        "subject_is_receiver": false,
        "subject_id": "9e474282-8b37-4d05-9c77-eab27976cfe9",
        "subject": {
          "updated_at": "2024-02-05T18:48:35.654100",
          "status": "approved",
          "social_name": "HORACIO SOTO MORALES",
          "rfc_pf": null,
          "required_clearance_level": 2,
          "references": [],
          "phone_number": "434898404898",
          "net_monthly_average_income": "50000.00",
          "inserted_at": "2021-03-26T20:22:04.358980",
          "id": "9e474282-8b37-4d05-9c77-eab27976cfe9",
          "fiscal_country": "Mexico",
          "email": "horacio@gmail.com",
          "document_type": "curp",
          "document_number": "SOMH031031HSRTRRA3",
          "clearance_level": 2,
          "birth_date": null,
          "address_street": "Calle Cannobio",
          "address_state": "PS",
          "address_postal_code": "39847389",
          "address_number": "75",
          "address_neighborhood": "Aldea Alpina",
          "address_country": "Mexico",
          "address_complement": "",
          "address_city": "Nuova Lima"
        },
        "status": "pending",
        "source_name": "HORACIO SOTO MORALES",
        "source_document_type": "curp",
        "source_document_number": "SOMH031031HSRTRRA3",
        "payment_method": null,
        "meta": null,
        "inserted_at": "2024-02-05T18:48:35.636805",
        "id": "a7ade569-2c89-40b4-8ec4-65a30cb7eacf",
        "from_credit_card": {
          "status": "tokenized",
          "inserted_at": "2024-02-05T18:48:35.634459",
          "id": "34193f52-1a40-4d32-a97f-e3658f6b8625"
        },
        "from_bank_account": null,
        "for_exchange": true,
        "exchange_under_request": false,
        "exchange_currency": "USD",
        "estimated_value_until_exchange": false,
        "currency": "MXN",
        "cleared": true,
        "bank_transaction": null
      }
    }
  },
  parameterPayload: [
    {
      name: "threeds",
      type: "object",
      required: true,
      description: "An object containing only the jwt token. You will get that token on the front-end"
    }
  ],
  domainsProperties: [
    {
      name: "4456528080389860, 4456529267234200, 4456529165328302, 4456524869770255",
      values: "Valid test cards that will trigger the 3ds OTP validation (must be above 1000 MXN)"
    },
    {
      name: "4456540000000063, 4456541249811088, 4456543371713314, 4456541982068615",
      values: "Valid test cards that will always approve, skipping the 3ds OTP validation"
    },
    {
      name: "4456530000000031, 4456530000000106, 4456536583667765, 4456536501449767",
      values: "Test cards that will fail the 3DS validation"
    },
    {
      name: "4456523340069956, 4456541249811088",
      values: "Test cards that will always fail"
    },
    {
      name: "4349003000047015, 4349001210846432, 4349001386781322, 4349003243371321",
      values: "Test cards that will always fail and the reason will be disclosed"
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/CreditCardMX.js